import DocumentHead from "src/components/shared/document-head";
import NotFound from "../components/shared/not-found";

export default function About() {
  return (
    <>
      <DocumentHead
        title="Difa Sulthon | About" 
        description="About Difa Sulthon"
      />
      <NotFound />
    </>
  )
}